import React, {Component} from 'react';
import {pageWithPrismic} from "../website-gridhaus/pageWithPrismic";
import {RichText} from "prismic-reactjs";
import ContactForm from "../parts/ContactForm";
import {ZapierService} from "../services/ZapierService";
import DownArrow from "../parts/DownArrow";
import {Helmet} from "react-helmet";
import {site} from "../config";
import {metaDescriptions, metaTitles} from "../website-gridhaus/meta";
import TrackedEmail from "../parts/TrackedEmail";
import {openChat} from "../utilities";
import ChatScrollTrigger from "../parts/ChatScrollTrigger";


class ContactPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactFormSubmitted: false
    };
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    window.analytics.page("Contact");
  }

  submit(values) {
    window.analytics.track("Submitted Callback Form", values);
    window.analytics.identify(values);

    return ZapierService.sendContactForm(values).then(response => {
      this.setState({
        contactFormSubmitted: true
      });
    }).catch(error => {
      console.error(error);
    });
  }

  render() {
    window.prerenderReady = false;
    if (this.props.page && this.props.page.doc) {
      window.prerenderReady = true;
      const data = this.props.page.doc.data;
      return (
        <div className={'page-contact'}>
          <Helmet>
            <title>{site.titlePrefix + 'Contact'}</title>
            {metaTitles(site.titlePrefix + 'Contact')}
            {metaDescriptions(RichText.asText(data.hero_message))}
          </Helmet>
          <ChatScrollTrigger time={0}/>
          <section className={'hero'} id={'hero'}>
            <div className={'container'}>
              <h1 className={'title'}>{data.hero_title}</h1>
              <div className={'brief'}>
                <p>Have a question? <a style={{cursor: 'pointer'}} onClick={openChat}>Chat with us</a> or email us
                  at <TrackedEmail onClick={openChat} onContextMenu={openChat} onCopy={openChat}
                                   location={'Contact Page'} email={'hello@gridhaus.com'}/>
                </p>
              </div>
            </div>
            <DownArrow scrollPastId={'hero'}/>
          </section>
          <div className={'content'}>
            <section className={'callback'}>
              <div className={'container'} data-aos="grid-fade-up">
                <div className={'text'}>
                  <h2 className={'title'}>{data.contact_title}</h2>
                  <div className={'brief'}>{RichText.render(data.contact_brief)}</div>
                </div>
                <div className={'form-container'} onClick={() => window.analytics.track('Clicked Callback Form')}>
                  <ContactForm onSubmit={this.submit}/>
                  {(this.state.contactFormSubmitted) ? (
                    <div className="success-message">Thank you for getting in touch, we'll speak to you
                      soon!</div>
                  ) : null}
                </div>
              </div>
            </section>
            <section className={'locations'}>
              <div className={'container'}>
                <ul className={'locations'}>
                  {data.locations.map((location) => (
                    <li key={location.name}>
                      <h2 className={'name'}>{location.name}</h2>
                      <div className={'brief'}>
                        {RichText.render(location.brief)}
                        <TrackedEmail onClick={openChat} onContextMenu={openChat} onCopy={openChat}
                                      email={location.email}/>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
            <section className={'business-info'}>
              <div className={'container'}>
                <ul className={'info-groups'}>
                  {data.info_groups.map((group) => (
                    <li key={group.title}>
                      <div className={'title'}>{group.title}</div>
                      <div className={'brief'}>
                        {RichText.render(group.brief)}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
          </div>
        </div>
      )
    }

    return null;
  }
}


export default pageWithPrismic(ContactPage, 'contact_page');


// WEBPACK FOOTER //
// ./src/pages/ContactPage.js